import React, {useState} from 'react';
import css from './HeaderContent.module.scss';
import {NavLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import FlexContainer from '../../FlexContainer/FlexContainer.jsx';
import HotelPickerButton from './HotelPickerButton';
import AppsPickerButton from './AppsPickerButton';
import UserFullNameWithPicture from './UserFullNameWithPicture.jsx';
import {useTrackedHotkeys} from "../../../hooks/useTrackedHotkeys.jsx";
import {useDemoMode} from "../../../providers/DemoModeProvider.jsx";

const HeaderContent = ({
  currentUser,
  currentHotel,
  linkTo,
  appsPickerProps = {},
  gap = 10,
  additionalContent,
  hotelSwitcherComponent: HotelSwitcherComponent,
}) => {
  const {isDemoMode} = useDemoMode();
  const [openSwitchHotel, setOpenSwitchHotel] = useState(false);
  useTrackedHotkeys('ctrl+H', () => {
    if (!currentUser?.hasAccessToMultipleHotels) {
      return;
    }
    setOpenSwitchHotel(true);
  })

  return (
    <>
      <FlexContainer className={css.headerContentContainer} alignItems="center" flexWrap="nowrap" gap={gap}>
        {additionalContent}
        <AppsPickerButton {...appsPickerProps} />
        <NavLink to={linkTo('account')} className={css.userLink}>
          <UserFullNameWithPicture
            userFullName={currentUser?.name}
            userProfilePicSrc={currentUser?.profilePictures && currentUser.profilePictures['30s']}
          />
        </NavLink>
        <HotelPickerButton
          currentHotel={currentHotel}
          onClick={() => isDemoMode ? {} : setOpenSwitchHotel(true)}
        />
      </FlexContainer>
      {openSwitchHotel && HotelSwitcherComponent &&
        <HotelSwitcherComponent onClose={() => setOpenSwitchHotel(false)} />
      }
    </>
  );
};

HeaderContent.propTypes = {
  currentUser: PropTypes.object,
  currentHotel: PropTypes.object,
  linkTo: PropTypes.func.isRequired,
  appsPickerProps: PropTypes.object,
  gap: PropTypes.number,
  additionalContent: PropTypes.node,
  hotelSwitcherComponent: PropTypes.elementType,
};

export default HeaderContent;
